import { render, staticRenderFns } from "./addExpressDialog.vue?vue&type=template&id=3c1b312d"
import script from "./addExpressDialog.vue?vue&type=script&lang=js"
export * from "./addExpressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports